import { useState } from "react";
import { format, parseISO } from "date-fns";
import { CalendarIcon, CheckCircle2 } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

export const DateOfBirthPicker = ({ value, onChange, age }) => {
  const [open, setOpen] = useState(false);
  const today = new Date();
  const selected = value ? parseISO(value) : undefined;
  const defaultMonth = selected || new Date(today.getFullYear() - 25, 0);

  const handleSelect = (date) => {
    if (!date) return;
    onChange(format(date, "yyyy-MM-dd"));
    setOpen(false);
  };

  return (
    <div>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            data-testid="dob-picker-trigger"
            className={cn(
              "input-omni w-full border border-input flex items-center gap-3 text-left",
              !selected && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="w-4 h-4 shrink-0 text-muted-foreground" />
            <span className="flex-1">
              {selected ? format(selected, "d MMMM yyyy") : "Tap to select your birthday"}
            </span>
            {age !== null && age >= 13 && <CheckCircle2 className="w-4 h-4 text-primary shrink-0" data-testid="dob-age-check" />}
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start" data-testid="dob-calendar">
          <Calendar
            mode="single"
            selected={selected}
            onSelect={handleSelect}
            defaultMonth={defaultMonth}
            captionLayout="dropdown-buttons"
            fromYear={today.getFullYear() - 100}
            toYear={today.getFullYear()}
            disabled={{ after: today }}
            classNames={{
              nav: "hidden",
              caption_dropdowns: "flex gap-1.5",
              caption_label: "hidden",
              dropdown: "rounded-md border border-input bg-background px-2 py-1.5 text-sm font-medium cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary/30",
              dropdown_month: "relative",
              dropdown_year: "relative",
              vhidden: "hidden",
            }}
          />
        </PopoverContent>
      </Popover>
      {age !== null && age >= 13 && (
        <p className="text-xs text-muted-foreground mt-1.5" data-testid="dob-age-hint">
          You're {age} — all set!
        </p>
      )}
    </div>
  );
};
